import request from '@/axios';

export const getPage = (current, size, params, AcceptLanguage) => {
  return request({
    url: '/emp-data-center/emp-data/item/page',
    method: 'get',
    filterEmptyParams: true,
    AcceptLanguage: AcceptLanguage,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getList = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/item/list',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getModelItemList = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemList',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const itemAlarmPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemAlarmPage',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}


export const getDetail = (params) => {
  return request({
    url: '/emp-data-center/emp-data/item/detail',
    method: 'get',
    params
  })
}

export const submit = (row) => {
  return request({
    url: '/emp-data-center/emp-data/item/submit',
    method: 'post',
    data: row
  })
}

export const remove = (ids) => {
  return request({
    url: '/emp-data-center/emp-data/item/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const submitModel = (row) => {
  return request({
    url: '/emp-data-center/emp-data/model/save',
    method: 'post',
    data: row
  })
}

export const updateModel = (row) => {
  return request({
    url: '/emp-data-center/emp-data/model/update',
    method: 'post',
    data: row
  })
}